import { BaseQueryFn, createApi } from '@reduxjs/toolkit/dist/query/react';
import { ClientError, GraphQLClient } from 'graphql-request';
import Cookies from 'js-cookie';

export const client = new GraphQLClient(
  `${process.env.NEXT_PUBLIC_API_URL}/graphql`
);

const baseQuery =
  (): BaseQueryFn<any, unknown, unknown> =>
  async (
    { document, variables }: { document: string; variables?: object },
    api
  ) => {
    try {
      const token = Cookies.get('ragya-token');
      if (token) {
        client.setHeader('Authorization', `${token}`);
      }

      const result = await client.request(document, variables);
      return { data: result };
    } catch (error) {
      if (error instanceof ClientError) {
        return { error: { status: error.response.status, data: error } };
      }
      return { error: { status: 500, data: error } };
    }
  };

export const api = createApi({
  baseQuery: baseQuery(),
  endpoints: () => ({}),
});
